import styled from 'styled-components';

export const ViewerLayout = styled.section`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  /* background:transparent; */
  background: '#111417';
  user-select: none;
`;
